import MuiGrid, { GridLegacyProps } from '@mui/material/GridLegacy';
import React from 'react';

export interface GridProps extends GridLegacyProps {}

/**
 * @deprecated
 */
export const Grid = (props: GridProps) => {
  return <MuiGrid {...props} />;
};
